import { css, styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

interface ButtonProps {
  active: boolean;
}

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #ffffff;
  padding: 20px 0;
`;

export const SectionHeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const TabButton = styled(Button)`
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  width: 160px;

  ${(props: ButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
      border-radius: 0;
    `}
`;
